export enum SaborCities {
  Abilene = 'abilene',
  Adkins = 'adkins',
  Alamo = 'alamo',
  AlamoHeights = 'alamoHeights',
  Alice = 'alice',
  Alpine = 'alpine',
  Amarillo = 'amarillo',
  Anahuac = 'anahuac',
  Angleton = 'angleton',
  Anna = 'anna',
  Aquilla = 'aquilla',
  AransasPass = 'aransasPass',
  AransasPassOther = 'aransasPassOther',
  Asherton = 'asherton',
  Atascosa = 'atascosa',
  Athens = 'athens',
  Austin = 'austin',
  Austwell = 'austwell',
  BalconesHeights = 'balconesHeights',
  Ballinger = 'ballinger',
  Bandera = 'bandera',
  Barksdale = 'barksdale',
  Bastrop = 'bastrop',
  Batesville = 'batesville',
  BayCity = 'bayCity',
  Bayside = 'bayside',
  Bayview = 'bayview',
  Beaumont = 'beaumont',
  Beeville = 'beeville',
  Belmont = 'belmont',
  BenBolt = 'benBolt',
  Benavides = 'benavides',
  BerclairGoliadCounty = 'berclairGoliadCounty',
  Bergheim = 'bergheim',
  Bertram = 'bertram',
  BexarCo = 'bexarCo',
  BigWells = 'bigWells',
  Bigfoot = 'bigfoot',
  Biry = 'biry',
  Bishop = 'bishop',
  Blanco = 'blanco',
  Bloomington = 'bloomington',
  Blum = 'blum',
  Boerne = 'boerne',
  BoldCypress = 'boldCypress',
  BonWier = 'bonWier',
  BonanzaBeach = 'bonanzaBeach',
  Brackettville = 'brackettville',
  Brady = 'brady',
  Bremond = 'bremond',
  Brenham = 'brenham',
  Bridgeport = 'bridgeport',
  Brownsville = 'brownsville',
  Brownwood = 'brownwood',
  Bruni = 'bruni',
  Bryan = 'bryan',
  BuchananDam = 'buchananDam',
  Buckholts = 'buckholts',
  Buda = 'buda',
  Bullard = 'bullard',
  Bulverde = 'bulverde',
  Burnet = 'burnet',
  Burton = 'burton',
  Caldwell = 'caldwell',
  Calliham = 'calliham',
  Calvert = 'calvert',
  CampVerde = 'campVerde',
  CampWood = 'campWood',
  Campbellton = 'campbellton',
  CanyonLake = 'canyonLake',
  CarrizoSprings = 'carrizoSprings',
  CastleHills = 'castleHills',
  Castroville = 'castroville',
  Catarina = 'catarina',
  Cathis = 'cathis',
  CedarCreek = 'cedarCreek',
  CedarPark = 'cedarPark',
  CenterPoint = 'centerPoint',
  ChapelHill = 'chapelHill',
  ChappellHill = 'chappellHill',
  Charlotte = 'charlotte',
  Cherokee = 'cherokee',
  Chilton = 'chilton',
  ChinaGrove = 'chinaGrove',
  Christine = 'christine',
  Cibolo = 'cibolo',
  CiboloCity = 'ciboloCity',
  Cleveland = 'cleveland',
  Clifton = 'clifton',
  CollegeStation = 'collegeStation',
  ColoradoCity = 'coloradoCity',
  Columbus = 'columbus',
  ComalClearwaterWest = 'comalClearwaterWest',
  Comfort = 'comfort',
  Comstock = 'comstock',
  ConCan = 'conCan',
  Conroe = 'conroe',
  Converse = 'converse',
  CopperasCove = 'copperasCove',
  CorpusChristi = 'corpusChristi',
  Corsicana = 'corsicana',
  Cost = 'cost',
  Cottonwood = 'cottonwood',
  CottonwoodShores = 'cottonwoodShores',
  Cotulla = 'cotulla',
  Coupland = 'coupland',
  CrossPlains = 'crossPlains',
  CrystalBeach = 'crystalBeach',
  CrystalCity = 'crystalCity',
  Cuero = 'cuero',
  Cypress = 'cypress',
  Dale = 'dale',
  Dallas = 'dallas',
  Dayton = 'dayton',
  DeLeon = 'deLeon',
  DeerPark = 'deerPark',
  DelRio = 'delRio',
  DelValle = 'delValle',
  Devine = 'devine',
  Dhanis = 'dhanis',
  Dickinson = 'dickinson',
  Dilley = 'dilley',
  Donna = 'donna',
  Doss = 'doss',
  Driftwood = 'driftwood',
  DrippingSprings = 'drippingSprings',
  Dryden = 'dryden',
  Dunlay = 'dunlay',
  EagleLake = 'eagleLake',
  EaglePass = 'eaglePass',
  EastBernard = 'eastBernard',
  Eastland = 'eastland',
  Ecleto = 'ecleto',
  EdCouch = 'edCouch',
  Edcouch = 'edcouch',
  Eden = 'eden',
  Edinburg = 'edinburg',
  Edna = 'edna',
  ElCampo = 'elCampo',
  ElIndio = 'elIndio',
  ElLago = 'elLago',
  ElPaso = 'elPaso',
  Eldorado = 'eldorado',
  Elgin = 'elgin',
  Elmendorf = 'elmendorf',
  Elsa = 'elsa',
  Encinal = 'encinal',
  Ennis = 'ennis',
  Etoile = 'etoile',
  Eustace = 'eustace',
  FairOaksRanch = 'fairOaksRanch',
  Fairfield = 'fairfield',
  Falfurrias = 'falfurrias',
  FallsCity = 'fallsCity',
  Fashing = 'fashing',
  Fentress = 'fentress',
  Fischer = 'fischer',
  FischerComal = 'fischerComal',
  Flatonia = 'flatonia',
  Flint = 'flint',
  Florence = 'florence',
  Floresville = 'floresville',
  FlourBluff = 'flourBluff',
  FortClarkSprings = 'fortClarkSprings',
  FortDavis = 'fortDavis',
  FortHancock = 'fortHancock',
  FortMcKavett = 'fortMcKavett',
  FortWorth = 'fortWorth',
  Fowlerton = 'fowlerton',
  Frankston = 'frankston',
  Fredericksburg = 'fredericksburg',
  Freeport = 'freeport',
  Freer = 'freer',
  Frisco = 'frisco',
  Fulton = 'fulton',
  Galveston = 'galveston',
  GardenRidge = 'gardenRidge',
  Garland = 'garland',
  Garwood = 'garwood',
  Gatesville = 'gatesville',
  Gause = 'gause',
  GeorgeWest = 'georgeWest',
  Georgetown = 'georgetown',
  Geronimo = 'geronimo',
  Giddings = 'giddings',
  Gillett = 'gillett',
  Goldsmith = 'goldsmith',
  Goldthwaite = 'goldthwaite',
  Goliad = 'goliad',
  Gonzales = 'gonzales',
  Graford = 'graford',
  Granbury = 'granbury',
  Grandview = 'grandview',
  Granger = 'granger',
  GraniteShoa = 'graniteShoa',
  Grapevine = 'grapevine',
  GreyForest = 'greyForest',
  Greywalls = 'greywalls',
  Guadalupe = 'guadalupe',
  Hallettsville = 'hallettsville',
  HaltomCity = 'haltomCity',
  Hamilton = 'hamilton',
  Hargill = 'hargill',
  HarkerHeights = 'harkerHeights',
  Harlingen = 'harlingen',
  Harper = 'harper',
  Harwood = 'harwood',
  Hebbronville = 'hebbronville',
  Helotes = 'helotes',
  Hempstead = 'hempstead',
  Henly = 'henly',
  Hidalgo = 'hidalgo',
  HiddenValleyHills = 'hiddenValleyHills',
  HighlandHaven = 'highlandHaven',
  HillCountryVillage = 'hillCountryVillage',
  HilltopLakes = 'hilltopLakes',
  Hobson = 'hobson',
  Holland = 'holland',
  HollywoodPa = 'hollywoodPa',
  Hondo = 'hondo',
  HorseshoeBay = 'horseshoeBay',
  Houston = 'houston',
  Humble = 'humble',
  Hunt = 'hunt',
  Huntsville = 'huntsville',
  Hutto = 'hutto',
  Hye = 'hye',
  Inez = 'inez',
  Ingleside = 'ingleside',
  Ingram = 'ingram',
  Iola = 'iola',
  Irving = 'irving',
  Jacksonville = 'jacksonville',
  Jarrell = 'jarrell',
  Jewett = 'jewett',
  JohnsonCity = 'johnsonCity',
  Jonestown = 'jonestown',
  Joshua = 'joshua',
  Jourdanton = 'jourdanton',
  Junction = 'junction',
  Karnes = 'karnes',
  KarnesCity = 'karnesCity',
  KatherineCourt = 'katherineCourt',
  Katy = 'katy',
  Kaufman = 'kaufman',
  Kempner = 'kempner',
  Kendalia = 'kendalia',
  Kendleton = 'kendleton',
  Kenedy = 'kenedy',
  Kerens = 'kerens',
  Kerrville = 'kerrville',
  Killeen = 'killeen',
  Kingsbury = 'kingsbury',
  Kingsland = 'kingsland',
  Kingsville = 'kingsville',
  Kingwood = 'kingwood',
  Kirby = 'kirby',
  Knippa = 'knippa',
  Koyote = 'koyote',
  Kyle = 'kyle',
  Kyote = 'kyote',
  LaFeria = 'laFeria',
  LaJoya = 'laJoya',
  LaPryor = 'laPryor',
  LaPryorOne = 'laPryorOne',
  LaVernia = 'laVernia',
  LaWard = 'laWard',
  LaCoste = 'laCoste',
  LagoVista = 'lagoVista',
  LaGrange = 'laGrange',
  LagunaVista = 'lagunaVista',
  Lakehills = 'lakehills',
  LakewayETJ = 'lakewayETJ',
  Lampasas = 'lampasas',
  Langtry = 'langtry',
  Laredo = 'laredo',
  Larue = 'larue',
  Lavaca = 'lavaca',
  LazyValley = 'lazyValley',
  Leakey = 'leakey',
  Leander = 'leander',
  Ledbetter = 'ledbetter',
  Leesburg = 'leesburg',
  Leesville = 'leesville',
  Leming = 'leming',
  LeonSprings = 'leonSprings',
  LeonValley = 'leonValley',
  Leonard = 'leonard',
  Lexington = 'lexington',
  LibertyHill = 'libertyHill',
  Lindale = 'lindale',
  Littlefield = 'littlefield',
  LiveOak = 'liveOak',
  Liverpool = 'liverpool',
  Llano = 'llano',
  Lockhart = 'lockhart',
  Lohn = 'lohn',
  Lometa = 'lometa',
  London = 'london',
  Longview = 'longview',
  LosFresnos = 'losFresnos',
  Lubbock = 'lubbock',
  Luckenbach = 'luckenbach',
  Lufkin = 'lufkin',
  Luling = 'luling',
  Lumberton = 'lumberton',
  Lytle = 'lytle',
  Macdona = 'macdona',
  Magnolia = 'magnolia',
  Manchaca = 'manchaca',
  Manor = 'manor',
  Marathon = 'marathon',
  MarbleFalls = 'marbleFalls',
  Marfa = 'marfa',
  Marion = 'marion',
  Mart = 'mart',
  Martindale = 'martindale',
  Mason = 'mason',
  Matagorda = 'matagorda',
  Mathis = 'mathis',
  Maxwell = 'maxwell',
  McAllen = 'mcAllen',
  McCamey = 'mcCamey',
  McCoy = 'mcCoy',
  McDade = 'mcDade',
  McGregor = 'mcGregor',
  McKinney = 'mcKinney',
  McQueeney = 'mcQueeney',
  Meadowlakes = 'meadowlakes',
  Medina = 'medina',
  Melvin = 'melvin',
  Menard = 'menard',
  Mercedes = 'mercedes',
  Mico = 'mico',
  Midland = 'midland',
  Milano = 'milano',
  Millett = 'millett',
  MineralWells = 'mineralWells',
  MirandoCity = 'mirandoCity',
  Mission = 'mission',
  MissouriCity = 'missouriCity',
  Monahans = 'monahans',
  Montalba = 'montalba',
  Montell = 'montell',
  Montgomery = 'montgomery',
  Moody = 'moody',
  Moore = 'moore',
  Morgan = 'morgan',
  MorganPointResort = 'morganPointResort',
  Moulton = 'moulton',
  MountainHom = 'mountainHom',
  MountainHome = 'mountainHome',
  Natalia = 'natalia',
  Nederland = 'nederland',
  NewBerlin = 'newBerlin',
  NewBraunfels = 'newBraunfels',
  Niederwald = 'niederwald',
  Nixon = 'nixon',
  Nome = 'nome',
  Nordheim = 'nordheim',
  NorthShoreEstates = 'northShoreEstates',
  NotApplicable = 'notApplicable',
  Notrees = 'notrees',
  NuecesCanyon = 'nuecesCanyon',
  Oakville = 'oakville',
  Odem = 'odem',
  Odessa = 'odessa',
  Odom = 'odom',
  OldGlory = 'oldGlory',
  OlmosPark = 'olmosPark',
  Onalaska = 'onalaska',
  Orange = 'orange',
  OrangeGrove = 'orangeGrove',
  OreCity = 'oreCity',
  Other = 'other',
  Ottine = 'ottine',
  Ozona = 'ozona',
  Paige = 'paige',
  PaintRock = 'paintRock',
  Palacios = 'palacios',
  Palestine = 'palestine',
  PalmValley = 'palmValley',
  Pandale = 'pandale',
  Pandora = 'pandora',
  Papalote = 'papalote',
  Paradise = 'paradise',
  Pasadena = 'pasadena',
  Pawnee = 'pawnee',
  Pearland = 'pearland',
  Pearsall = 'pearsall',
  Pecos = 'pecos',
  Penitas = 'penitas',
  Penwell = 'penwell',
  Pettus = 'pettus',
  Pflugervil = 'pflugervil',
  Pharr = 'pharr',
  Phoenix = 'phoenix',
  PipeCreek = 'pipeCreek',
  Plano = 'plano',
  Plantersville = 'plantersville',
  Pleasanton = 'pleasanton',
  Pontotoc = 'pontotoc',
  PortAransas = 'portAransas',
  PortIsabel = 'portIsabel',
  PortLaVaca = 'portLaVaca',
  PortMansfield = 'portMansfield',
  PortNeches = 'portNeches',
  PortOConnor = 'portOConnor',
  Portland = 'portland',
  Poteet = 'poteet',
  Poth = 'poth',
  Pottsboro = 'pottsboro',
  PrairieLea = 'prairieLea',
  Premont = 'premont',
  Progreso = 'progreso',
  Pyote = 'pyote',
  Quemado = 'quemado',
  RanchoViejo = 'ranchoViejo',
  Raymondvil = 'raymondvil',
  ReaganWells = 'reaganWells',
  Realitos = 'realitos',
  Refugio = 'refugio',
  RiataTerrace = 'riataTerrace',
  Richardson = 'richardson',
  Richmond = 'richmond',
  RioFrio = 'rioFrio',
  RioGrandeCity = 'rioGrandeCity',
  RioHondo = 'rioHondo',
  RioMedina = 'rioMedina',
  RisingStar = 'risingStar',
  Riviera = 'riviera',
  Robstown = 'robstown',
  Rochelle = 'rochelle',
  Rockport = 'rockport',
  Rocksprings = 'rocksprings',
  Rockwall = 'rockwall',
  Roma = 'roma',
  Roosevelt = 'roosevelt',
  Rosanky = 'rosanky',
  RoundMountain = 'roundMountain',
  RoundRock = 'roundRock',
  Rowlett = 'rowlett',
  Royse = 'royse',
  RunawayBay = 'runawayBay',
  Runge = 'runge',
  Sabinal = 'sabinal',
  SanAngelo = 'sanAngelo',
  SanAntonio = 'sanAntonio',
  SanBenito = 'sanBenito',
  SanDiego = 'sanDiego',
  SanJuan = 'sanJuan',
  SanMarcos = 'sanMarcos',
  SanSaba = 'sanSaba',
  Sanderson = 'sanderson',
  Sandia = 'sandia',
  Sanger = 'sanger',
  SantaClara = 'santaClara',
  SantaFe = 'santaFe',
  SantaRosa = 'santaRosa',
  Saspamco = 'saspamco',
  Schertz = 'schertz',
  Schulenburg = 'schulenburg',
  Seadrift = 'seadrift',
  Sealy = 'sealy',
  Sebastian = 'sebastian',
  Seguin = 'seguin',
  Selma = 'selma',
  Seminole = 'seminole',
  ShadyShores = 'shadyShores',
  ShavanoPark = 'shavanoPark',
  Sheffield = 'sheffield',
  Sherman = 'sherman',
  Shiner = 'shiner',
  SierraBlanca = 'sierraBlanca',
  Sinton = 'sinton',
  Sisterdale = 'sisterdale',
  Skidmore = 'skidmore',
  Smiley = 'smiley',
  Smithville = 'smithville',
  Somerset = 'somerset',
  Somerville = 'somerville',
  Sonora = 'sonora',
  SouthPadreIsland = 'southPadreIsland',
  Spicewood = 'spicewood',
  Spofford = 'spofford',
  Spring = 'spring',
  SpringBranch = 'springBranch',
  StHedwig = 'stHedwig',
  StHedwigOne = 'stHedwigOne',
  Staples = 'staples',
  Startzville = 'startzville',
  Stephenville = 'stephenville',
  Stockdale = 'stockdale',
  Stonewall = 'stonewall',
  Streetman = 'streetman',
  Sublime = 'sublime',
  Sudan = 'sudan',
  SugarLand = 'sugarLand',
  SulphurSprings = 'sulphurSprings',
  SunriseBeach = 'sunriseBeach',
  SutherlandSprings = 'sutherlandSprings',
  Tarpley = 'tarpley',
  Taylor = 'taylor',
  Temple = 'temple',
  TennesseeColony = 'tennesseeColony',
  Terlingua = 'terlingua',
  Terrell = 'terrell',
  TerrellHills = 'terrellHills',
  Texarkana = 'texarkana',
  TheHills = 'theHills',
  TheWoodlands = 'theWoodlands',
  Thelma = 'thelma',
  Thorndale = 'thorndale',
  Thrall = 'thrall',
  ThreeRivers = 'threeRivers',
  Tilden = 'tilden',
  Tivoli = 'tivoli',
  Tomball = 'tomball',
  Tow = 'tow',
  TrophyClub = 'trophyClub',
  Troy = 'troy',
  Tulia = 'tulia',
  Tulsita = 'tulsita',
  Tyler = 'tyler',
  Uhland = 'uhland',
  Uncertain = 'uncertain',
  Unincorp = 'unincorp',
  UniversalCity = 'universalCity',
  Utopia = 'utopia',
  Uvalde = 'uvalde',
  ValleySpring = 'valleySpring',
  VanHorn = 'vanHorn',
  Vanderpool = 'vanderpool',
  Venus = 'venus',
  Victoria = 'victoria',
  Vidor = 'vidor',
  VistaPoint = 'vistaPoint',
  Volente = 'volente',
  VonOrmy = 'vonOrmy',
  Waco = 'waco',
  Waelder = 'waelder',
  Waller = 'waller',
  Waring = 'waring',
  Waxahachie = 'waxahachie',
  Weimar = 'weimar',
  Welder = 'welder',
  Welfare = 'welfare',
  Weslaco = 'weslaco',
  WestPoint = 'westPoint',
  Westhoff = 'westhoff',
  Wharton = 'wharton',
  Whitehouse = 'whitehouse',
  Whitesboro = 'whitesboro',
  Whitney = 'whitney',
  Whitsett = 'whitsett',
  WillowCity = 'willowCity',
  Wimberley = 'wimberley',
  Winchester = 'winchester',
  Windcrest = 'windcrest',
  Woodsboro = 'woodsboro',
  Wrightsboro = 'wrightsboro',
  Yancey = 'yancey',
  Yoakum = 'yoakum',
  YorkTown = 'yorkTown',
  Zapata = 'zapata',
  Zorn = 'zorn'
}

export const SaborCitiesLabel: Record<SaborCities, string> = {
  [SaborCities.Abilene]: 'Abilene',
  [SaborCities.Adkins]: 'Adkins',
  [SaborCities.Alamo]: 'Alamo',
  [SaborCities.AlamoHeights]: 'Alamo Heights',
  [SaborCities.Alice]: 'Alice',
  [SaborCities.Alpine]: 'Alpine',
  [SaborCities.Amarillo]: 'Amarillo',
  [SaborCities.Anahuac]: 'Anahuac',
  [SaborCities.Angleton]: 'Angleton',
  [SaborCities.Anna]: 'Anna',
  [SaborCities.Aquilla]: 'Aquilla',
  [SaborCities.AransasPass]: 'Aransas Pass',
  [SaborCities.AransasPassOther]: 'Aransas Pass',
  [SaborCities.Asherton]: 'Asherton',
  [SaborCities.Atascosa]: 'Atascosa',
  [SaborCities.Athens]: 'Athens',
  [SaborCities.Austin]: 'Austin',
  [SaborCities.Austwell]: 'Austwell',
  [SaborCities.BalconesHeights]: 'Balcones Heights',
  [SaborCities.Ballinger]: 'Ballinger',
  [SaborCities.Bandera]: 'Bandera',
  [SaborCities.Barksdale]: 'Barksdale',
  [SaborCities.Bastrop]: 'Bastrop',
  [SaborCities.Batesville]: 'Batesville',
  [SaborCities.BayCity]: 'Bay City',
  [SaborCities.Bayside]: 'Bayside',
  [SaborCities.Bayview]: 'Bayview',
  [SaborCities.Beaumont]: 'Beaumont',
  [SaborCities.Beeville]: 'Beeville',
  [SaborCities.Belmont]: 'Belmont',
  [SaborCities.BenBolt]: 'Ben Bolt',
  [SaborCities.Benavides]: 'Benavides',
  [SaborCities.BerclairGoliadCounty]: 'Berclair Goliad County',
  [SaborCities.Bergheim]: 'Bergheim',
  [SaborCities.Bertram]: 'Bertram',
  [SaborCities.BexarCo]: 'Bexar Co',
  [SaborCities.BigWells]: 'Big Wells',
  [SaborCities.Bigfoot]: 'Bigfoot',
  [SaborCities.Biry]: 'Biry',
  [SaborCities.Bishop]: 'Bishop',
  [SaborCities.Blanco]: 'Blanco',
  [SaborCities.Bloomington]: 'Bloomington',
  [SaborCities.Blum]: 'Blum',
  [SaborCities.Boerne]: 'Boerne',
  [SaborCities.BoldCypress]: 'Bold Cypress',
  [SaborCities.BonWier]: 'Bon Wier',
  [SaborCities.BonanzaBeach]: 'Bonanza Beach',
  [SaborCities.Brackettville]: 'Brackettville',
  [SaborCities.Brady]: 'Brady',
  [SaborCities.Bremond]: 'Bremond',
  [SaborCities.Brenham]: 'Brenham',
  [SaborCities.Bridgeport]: 'Bridgeport',
  [SaborCities.Brownsville]: 'Brownsville',
  [SaborCities.Brownwood]: 'Brownwood',
  [SaborCities.Bruni]: 'Bruni',
  [SaborCities.Bryan]: 'Bryan',
  [SaborCities.BuchananDam]: 'Buchanan Dam',
  [SaborCities.Buckholts]: 'Buckholts',
  [SaborCities.Buda]: 'Buda',
  [SaborCities.Bullard]: 'Bullard',
  [SaborCities.Bulverde]: 'Bulverde',
  [SaborCities.Burnet]: 'Burnet',
  [SaborCities.Burton]: 'Burton',
  [SaborCities.Caldwell]: 'Caldwell',
  [SaborCities.Calliham]: 'Calliham',
  [SaborCities.Calvert]: 'Calvert',
  [SaborCities.CampVerde]: 'Camp Verde',
  [SaborCities.CampWood]: 'Camp Wood',
  [SaborCities.Campbellton]: 'Campbellton',
  [SaborCities.CanyonLake]: 'Canyon Lake',
  [SaborCities.CarrizoSprings]: 'Carrizo Springs',
  [SaborCities.CastleHills]: 'Castle Hills',
  [SaborCities.Castroville]: 'Castroville',
  [SaborCities.Catarina]: 'Catarina',
  [SaborCities.Cathis]: 'Cathis',
  [SaborCities.CedarCreek]: 'Cedar Creek',
  [SaborCities.CedarPark]: 'cedar park',
  [SaborCities.CenterPoint]: 'Center Point',
  [SaborCities.ChapelHill]: 'Chapel Hill',
  [SaborCities.ChappellHill]: 'Chappell Hill',
  [SaborCities.Charlotte]: 'Charlotte',
  [SaborCities.Cherokee]: 'Cherokee',
  [SaborCities.Chilton]: 'Chilton',
  [SaborCities.ChinaGrove]: 'China Grove',
  [SaborCities.Christine]: 'Christine',
  [SaborCities.Cibolo]: 'Cibolo',
  [SaborCities.CiboloCity]: 'Cibolo City',
  [SaborCities.Cleveland]: 'Cleveland',
  [SaborCities.Clifton]: 'Clifton',
  [SaborCities.CollegeStation]: 'College Station',
  [SaborCities.ColoradoCity]: 'Colorado City',
  [SaborCities.Columbus]: 'Columbus',
  [SaborCities.ComalClearwaterWest]: 'Comal Clearwater Estates Property Owners Association, Inc.',
  [SaborCities.Comfort]: 'Comfort',
  [SaborCities.Comstock]: 'Comstock',
  [SaborCities.ConCan]: 'ConCan',
  [SaborCities.Conroe]: 'Conroe',
  [SaborCities.Converse]: 'Converse',
  [SaborCities.CopperasCove]: 'Copperas Cove',
  [SaborCities.CorpusChristi]: 'Corpus Christi',
  [SaborCities.Corsicana]: 'Corsicana',
  [SaborCities.Cost]: 'Cost',
  [SaborCities.Cottonwood]: 'Cottonwood',
  [SaborCities.CottonwoodShores]: 'Cottonwood Shores',
  [SaborCities.Cotulla]: 'Cotulla',
  [SaborCities.Coupland]: 'Coupland',
  [SaborCities.CrossPlains]: 'Cross Plains',
  [SaborCities.CrystalBeach]: 'Crystal Beach',
  [SaborCities.CrystalCity]: 'Crystal City',
  [SaborCities.Cuero]: 'Cuero',
  [SaborCities.Cypress]: 'Cypress',
  [SaborCities.Dale]: 'Dale',
  [SaborCities.Dallas]: 'Dallas',
  [SaborCities.Dayton]: 'Dayton',
  [SaborCities.DeLeon]: 'De Leon',
  [SaborCities.DeerPark]: 'Deer Park',
  [SaborCities.DelRio]: 'Del Rio',
  [SaborCities.DelValle]: 'Del Valle',
  [SaborCities.Devine]: 'Devine',
  [SaborCities.Dhanis]: 'Dhanis',
  [SaborCities.Dickinson]: 'Dickinson',
  [SaborCities.Dilley]: 'Dilley',
  [SaborCities.Donna]: 'Donna',
  [SaborCities.Doss]: 'Doss',
  [SaborCities.Driftwood]: 'Driftwood',
  [SaborCities.DrippingSprings]: 'Dripping Springs',
  [SaborCities.Dryden]: 'Dryden',
  [SaborCities.Dunlay]: 'Dunlay',
  [SaborCities.EagleLake]: 'Eagle Lake',
  [SaborCities.EaglePass]: 'Eagle Pass',
  [SaborCities.EastBernard]: 'East Bernard',
  [SaborCities.Eastland]: 'Eastland',
  [SaborCities.Ecleto]: 'Ecleto',
  [SaborCities.EdCouch]: 'Ed Couch',
  [SaborCities.Edcouch]: 'Edcouch',
  [SaborCities.Eden]: 'Eden',
  [SaborCities.Edinburg]: 'Edinburg',
  [SaborCities.Edna]: 'Edna',
  [SaborCities.ElCampo]: 'El Campo',
  [SaborCities.ElIndio]: 'El Indio',
  [SaborCities.ElLago]: 'El Lago',
  [SaborCities.ElPaso]: 'El Paso',
  [SaborCities.Eldorado]: 'Eldorado',
  [SaborCities.Elgin]: 'Elgin',
  [SaborCities.Elmendorf]: 'Elmendorf',
  [SaborCities.Elsa]: 'Elsa',
  [SaborCities.Encinal]: 'Encinal',
  [SaborCities.Ennis]: 'Ennis',
  [SaborCities.Etoile]: 'Etoile',
  [SaborCities.Eustace]: 'Eustace',
  [SaborCities.FairOaksRanch]: 'Fair Oaks Ranch',
  [SaborCities.Fairfield]: 'Fairfield',
  [SaborCities.Falfurrias]: 'Falfurrias',
  [SaborCities.FallsCity]: 'Falls City',
  [SaborCities.Fashing]: 'Fashing',
  [SaborCities.Fentress]: 'Fentress',
  [SaborCities.Fischer]: 'Fischer',
  [SaborCities.FischerComal]: 'Fischer (Comal)',
  [SaborCities.Flatonia]: 'Flatonia',
  [SaborCities.Flint]: 'Flint',
  [SaborCities.Florence]: 'Florence',
  [SaborCities.Floresville]: 'Floresville',
  [SaborCities.FlourBluff]: 'Flour Bluff',
  [SaborCities.FortClarkSprings]: 'Fort Clark Springs',
  [SaborCities.FortDavis]: 'Fort Davis',
  [SaborCities.FortHancock]: 'Fort Hancock',
  [SaborCities.FortMcKavett]: 'Fort McKavett',
  [SaborCities.FortWorth]: 'Fort Worth',
  [SaborCities.Fowlerton]: 'Fowlerton',
  [SaborCities.Frankston]: 'Frankston',
  [SaborCities.Fredericksburg]: 'Fredericksburg',
  [SaborCities.Freeport]: 'Freeport',
  [SaborCities.Freer]: 'Freer',
  [SaborCities.Frisco]: 'Frisco',
  [SaborCities.Fulton]: 'Fulton',
  [SaborCities.Galveston]: 'Galveston',
  [SaborCities.GardenRidge]: 'Garden Ridge',
  [SaborCities.Garland]: 'Garland',
  [SaborCities.Garwood]: 'Garwood',
  [SaborCities.Gatesville]: 'Gatesville',
  [SaborCities.Gause]: 'Gause',
  [SaborCities.GeorgeWest]: 'George West',
  [SaborCities.Georgetown]: 'Georgetown',
  [SaborCities.Geronimo]: 'Geronimo',
  [SaborCities.Giddings]: 'Giddings',
  [SaborCities.Gillett]: 'Gillett',
  [SaborCities.Goldsmith]: 'Goldsmith',
  [SaborCities.Goldthwaite]: 'Goldthwaite',
  [SaborCities.Goliad]: 'Goliad',
  [SaborCities.Gonzales]: 'Gonzales',
  [SaborCities.Graford]: 'Graford',
  [SaborCities.Granbury]: 'Granbury',
  [SaborCities.Grandview]: 'Grandview',
  [SaborCities.Granger]: 'Granger',
  [SaborCities.GraniteShoa]: 'Granite Shoa',
  [SaborCities.Grapevine]: 'Grapevine',
  [SaborCities.GreyForest]: 'Grey Forest',
  [SaborCities.Greywalls]: 'Greywalls',
  [SaborCities.Guadalupe]: 'Guadalupe',
  [SaborCities.Hallettsville]: 'Hallettsville',
  [SaborCities.HaltomCity]: 'Haltom City',
  [SaborCities.Hamilton]: 'Hamilton',
  [SaborCities.Hargill]: 'Hargill',
  [SaborCities.HarkerHeights]: 'Harker Heights',
  [SaborCities.Harlingen]: 'Harlingen',
  [SaborCities.Harper]: 'Harper',
  [SaborCities.Harwood]: 'Harwood',
  [SaborCities.Hebbronville]: 'Hebbronville',
  [SaborCities.Helotes]: 'Helotes',
  [SaborCities.Hempstead]: 'Hempstead',
  [SaborCities.Henly]: 'Henly',
  [SaborCities.Hidalgo]: 'Hidalgo',
  [SaborCities.HiddenValleyHills]: 'Hidden Valley Hills',
  [SaborCities.HighlandHaven]: 'Highland Haven',
  [SaborCities.HillCountryVillage]: 'Hill Country Village',
  [SaborCities.HilltopLakes]: 'Hilltop Lakes',
  [SaborCities.Hobson]: 'Hobson',
  [SaborCities.Holland]: 'Holland',
  [SaborCities.HollywoodPa]: 'Hollywood Pa',
  [SaborCities.Hondo]: 'Hondo',
  [SaborCities.HorseshoeBay]: 'Horseshoe Bay',
  [SaborCities.Houston]: 'Houston',
  [SaborCities.Humble]: 'Humble',
  [SaborCities.Hunt]: 'Hunt',
  [SaborCities.Huntsville]: 'Huntsville',
  [SaborCities.Hutto]: 'Hutto',
  [SaborCities.Hye]: 'Hye',
  [SaborCities.Inez]: 'Inez',
  [SaborCities.Ingleside]: 'Ingleside',
  [SaborCities.Ingram]: 'Ingram',
  [SaborCities.Iola]: 'Iola',
  [SaborCities.Irving]: 'Irving',
  [SaborCities.Jacksonville]: 'Jacksonville',
  [SaborCities.Jarrell]: 'Jarrell',
  [SaborCities.Jewett]: 'Jewett',
  [SaborCities.JohnsonCity]: 'Johnson City',
  [SaborCities.Jonestown]: 'Jonestown',
  [SaborCities.Joshua]: 'Joshua',
  [SaborCities.Jourdanton]: 'Jourdanton',
  [SaborCities.Junction]: 'Junction',
  [SaborCities.Karnes]: 'Karnes',
  [SaborCities.KarnesCity]: 'Karnes City',
  [SaborCities.KatherineCourt]: 'Katherine Court Homeowners Association, Inc.',
  [SaborCities.Katy]: 'Katy',
  [SaborCities.Kaufman]: 'Kaufman',
  [SaborCities.Kempner]: 'Kempner',
  [SaborCities.Kendalia]: 'Kendalia',
  [SaborCities.Kendleton]: 'Kendleton',
  [SaborCities.Kenedy]: 'Kenedy',
  [SaborCities.Kerens]: 'Kerens',
  [SaborCities.Kerrville]: 'Kerrville',
  [SaborCities.Killeen]: 'Killeen',
  [SaborCities.Kingsbury]: 'Kingsbury',
  [SaborCities.Kingsland]: 'Kingsland',
  [SaborCities.Kingsville]: 'Kingsville',
  [SaborCities.Kingwood]: 'Kingwood',
  [SaborCities.Kirby]: 'Kirby',
  [SaborCities.Knippa]: 'Knippa',
  [SaborCities.Koyote]: 'Koyote',
  [SaborCities.Kyle]: 'Kyle',
  [SaborCities.Kyote]: 'Kyote',
  [SaborCities.LaFeria]: 'La Feria',
  [SaborCities.LaJoya]: 'La Joya',
  [SaborCities.LaPryor]: 'LaPryor',
  [SaborCities.LaPryorOne]: 'La Pryor',
  [SaborCities.LaVernia]: 'La Vernia',
  [SaborCities.LaWard]: 'La Ward',
  [SaborCities.LaCoste]: 'LaCoste',
  [SaborCities.LagoVista]: 'Lago Vista',
  [SaborCities.LaGrange]: 'LaGrange',
  [SaborCities.LagunaVista]: 'Laguna Vista',
  [SaborCities.Lakehills]: 'Lakehills',
  [SaborCities.LakewayETJ]: 'Lakeway ETJ',
  [SaborCities.Lampasas]: 'Lampasas',
  [SaborCities.Langtry]: 'Langtry',
  [SaborCities.Laredo]: 'Laredo',
  [SaborCities.Larue]: 'Larue',
  [SaborCities.Lavaca]: 'Lavaca',
  [SaborCities.LazyValley]: 'Lazy Valley',
  [SaborCities.Leakey]: 'Leakey',
  [SaborCities.Leander]: 'Leander',
  [SaborCities.Ledbetter]: 'Ledbetter',
  [SaborCities.Leesburg]: 'Leesburg',
  [SaborCities.Leesville]: 'Leesville',
  [SaborCities.Leming]: 'Leming',
  [SaborCities.LeonSprings]: 'Leon Springs',
  [SaborCities.LeonValley]: 'Leon Valley',
  [SaborCities.Leonard]: 'Leonard',
  [SaborCities.Lexington]: 'Lexington',
  [SaborCities.LibertyHill]: 'Liberty Hill',
  [SaborCities.Lindale]: 'Lindale',
  [SaborCities.Littlefield]: 'Littlefield',
  [SaborCities.LiveOak]: 'Live Oak',
  [SaborCities.Liverpool]: 'Liverpool',
  [SaborCities.Llano]: 'Llano',
  [SaborCities.Lockhart]: 'Lockhart',
  [SaborCities.Lohn]: 'Lohn',
  [SaborCities.Lometa]: 'Lometa',
  [SaborCities.London]: 'London',
  [SaborCities.Longview]: 'Longview',
  [SaborCities.LosFresnos]: 'Los Fresnos',
  [SaborCities.Lubbock]: 'Lubbock',
  [SaborCities.Luckenbach]: 'Luckenbach',
  [SaborCities.Lufkin]: 'Lufkin',
  [SaborCities.Luling]: 'Luling',
  [SaborCities.Lumberton]: 'Lumberton',
  [SaborCities.Lytle]: 'Lytle',
  [SaborCities.Macdona]: 'Macdona',
  [SaborCities.Magnolia]: 'Magnolia',
  [SaborCities.Manchaca]: 'Manchaca',
  [SaborCities.Manor]: 'Manor',
  [SaborCities.Marathon]: 'Marathon',
  [SaborCities.MarbleFalls]: 'Marble Falls',
  [SaborCities.Marfa]: 'Marfa',
  [SaborCities.Marion]: 'Marion',
  [SaborCities.Mart]: 'Mart',
  [SaborCities.Martindale]: 'Martindale',
  [SaborCities.Mason]: 'Mason',
  [SaborCities.Matagorda]: 'Matagorda',
  [SaborCities.Mathis]: 'Mathis',
  [SaborCities.Maxwell]: 'Maxwell',
  [SaborCities.McAllen]: 'McAllen',
  [SaborCities.McCamey]: 'McCamey',
  [SaborCities.McCoy]: 'McCoy',
  [SaborCities.McDade]: 'McDade',
  [SaborCities.McGregor]: 'McGregor',
  [SaborCities.McKinney]: 'McKinney',
  [SaborCities.McQueeney]: 'McQueeney',
  [SaborCities.Meadowlakes]: 'Meadowlakes',
  [SaborCities.Medina]: 'Medina',
  [SaborCities.Melvin]: 'Melvin',
  [SaborCities.Menard]: 'Menard',
  [SaborCities.Mercedes]: 'Mercedes',
  [SaborCities.Mico]: 'Mico',
  [SaborCities.Midland]: 'Midland',
  [SaborCities.Milano]: 'Milano',
  [SaborCities.Millett]: 'Millett',
  [SaborCities.MineralWells]: 'Mineral Wells',
  [SaborCities.MirandoCity]: 'Mirando City',
  [SaborCities.Mission]: 'Mission',
  [SaborCities.MissouriCity]: 'Missouri City',
  [SaborCities.Monahans]: 'Monahans',
  [SaborCities.Montalba]: 'Montalba',
  [SaborCities.Montell]: 'Montell',
  [SaborCities.Montgomery]: 'Montgomery',
  [SaborCities.Moody]: 'Moody',
  [SaborCities.Moore]: 'Moore',
  [SaborCities.Morgan]: 'Morgan',
  [SaborCities.MorganPointResort]: "Morgan's Point Resort",
  [SaborCities.Moulton]: 'Moulton',
  [SaborCities.MountainHom]: 'Mountain Hom',
  [SaborCities.MountainHome]: 'Mountain Home',
  [SaborCities.Natalia]: 'Natalia',
  [SaborCities.Nederland]: 'Nederland',
  [SaborCities.NewBerlin]: 'New Berlin',
  [SaborCities.NewBraunfels]: 'New Braunfels',
  [SaborCities.Niederwald]: 'Niederwald',
  [SaborCities.Nixon]: 'Nixon',
  [SaborCities.Nome]: 'Nome',
  [SaborCities.Nordheim]: 'Nordheim',
  [SaborCities.NorthShoreEstates]: 'North Shore Estates',
  [SaborCities.NotApplicable]: 'Not Applicab',
  [SaborCities.Notrees]: 'Notrees',
  [SaborCities.NuecesCanyon]: 'Nueces Canyon',
  [SaborCities.Oakville]: 'Oakville',
  [SaborCities.Odem]: 'Odem',
  [SaborCities.Odessa]: 'Odessa',
  [SaborCities.Odom]: 'Odom',
  [SaborCities.OldGlory]: 'Old Glory',
  [SaborCities.OlmosPark]: 'Olmos Park',
  [SaborCities.Onalaska]: 'Onalaska',
  [SaborCities.Orange]: 'Orange',
  [SaborCities.OrangeGrove]: 'Orange Grove',
  [SaborCities.OreCity]: 'Ore City',
  [SaborCities.Other]: 'Other',
  [SaborCities.Ottine]: 'Ottine',
  [SaborCities.Ozona]: 'Ozona',
  [SaborCities.Paige]: 'Paige',
  [SaborCities.PaintRock]: 'Paint Rock',
  [SaborCities.Palacios]: 'Palacios',
  [SaborCities.Palestine]: 'Palestine',
  [SaborCities.PalmValley]: 'Palm Valley',
  [SaborCities.Pandale]: 'Pandale',
  [SaborCities.Pandora]: 'Pandora',
  [SaborCities.Papalote]: 'Papalote',
  [SaborCities.Paradise]: 'Paradise',
  [SaborCities.Pasadena]: 'Pasadena',
  [SaborCities.Pawnee]: 'Pawnee',
  [SaborCities.Pearland]: 'Pearland',
  [SaborCities.Pearsall]: 'Pearsall',
  [SaborCities.Pecos]: 'Pecos',
  [SaborCities.Penitas]: 'Penitas',
  [SaborCities.Penwell]: 'Penwell',
  [SaborCities.Pettus]: 'Pettus',
  [SaborCities.Pflugervil]: 'Pflugervil',
  [SaborCities.Pharr]: 'Pharr',
  [SaborCities.Phoenix]: 'Phoenix',
  [SaborCities.PipeCreek]: 'Pipe Creek',
  [SaborCities.Plano]: 'Plano',
  [SaborCities.Plantersville]: 'Plantersville',
  [SaborCities.Pleasanton]: 'Pleasanton',
  [SaborCities.Pontotoc]: 'Pontotoc',
  [SaborCities.PortAransas]: 'Port Aransas',
  [SaborCities.PortIsabel]: 'Port Isabel',
  [SaborCities.PortLaVaca]: 'Port LaVaca',
  [SaborCities.PortMansfield]: 'Port Mansfield',
  [SaborCities.PortNeches]: 'Port Neches',
  [SaborCities.PortOConnor]: "Port O'Connor",
  [SaborCities.Portland]: 'Portland',
  [SaborCities.Poteet]: 'Poteet',
  [SaborCities.Poth]: 'Poth',
  [SaborCities.Pottsboro]: 'Pottsboro',
  [SaborCities.PrairieLea]: 'Prairie Lea',
  [SaborCities.Premont]: 'Premont',
  [SaborCities.Progreso]: 'Progreso',
  [SaborCities.Pyote]: 'Pyote',
  [SaborCities.Quemado]: 'Quemado',
  [SaborCities.RanchoViejo]: 'Rancho Viejo',
  [SaborCities.Raymondvil]: 'Raymondvil',
  [SaborCities.ReaganWells]: 'Reagan Wells',
  [SaborCities.Realitos]: 'Realitos',
  [SaborCities.Refugio]: 'Refugio',
  [SaborCities.RiataTerrace]: 'Riata Terrace',
  [SaborCities.Richardson]: 'Richardson',
  [SaborCities.Richmond]: 'Richmond',
  [SaborCities.RioFrio]: 'Rio Frio',
  [SaborCities.RioGrandeCity]: 'Rio Grande City',
  [SaborCities.RioHondo]: 'Rio Hondo',
  [SaborCities.RioMedina]: 'Rio Medina',
  [SaborCities.RisingStar]: 'Rising Star',
  [SaborCities.Riviera]: 'Riviera',
  [SaborCities.Robstown]: 'Robstown',
  [SaborCities.Rochelle]: 'Rochelle',
  [SaborCities.Rockport]: 'Rockport',
  [SaborCities.Rocksprings]: 'Rocksprings',
  [SaborCities.Rockwall]: 'Rockwall',
  [SaborCities.Roma]: 'Roma',
  [SaborCities.Roosevelt]: 'Roosevelt',
  [SaborCities.Rosanky]: 'Rosanky',
  [SaborCities.RoundMountain]: 'Round Mountain',
  [SaborCities.RoundRock]: 'Round Rock',
  [SaborCities.Rowlett]: 'Rowlett',
  [SaborCities.Royse]: 'Royse',
  [SaborCities.RunawayBay]: 'Runaway Bay',
  [SaborCities.Runge]: 'Runge',
  [SaborCities.Sabinal]: 'Sabinal',
  [SaborCities.SanAngelo]: 'San Angelo',
  [SaborCities.SanAntonio]: 'San Antonio',
  [SaborCities.SanBenito]: 'San Benito',
  [SaborCities.SanDiego]: 'San Diego',
  [SaborCities.SanJuan]: 'San Juan',
  [SaborCities.SanMarcos]: 'San Marcos',
  [SaborCities.SanSaba]: 'San Saba',
  [SaborCities.Sanderson]: 'Sanderson',
  [SaborCities.Sandia]: 'Sandia',
  [SaborCities.Sanger]: 'Sanger',
  [SaborCities.SantaClara]: 'Santa Clara',
  [SaborCities.SantaFe]: 'Santa Fe',
  [SaborCities.SantaRosa]: 'Santa Rosa',
  [SaborCities.Saspamco]: 'Saspamco',
  [SaborCities.Schertz]: 'Schertz',
  [SaborCities.Schulenburg]: 'Schulenburg',
  [SaborCities.Seadrift]: 'Seadrift',
  [SaborCities.Sealy]: 'Sealy',
  [SaborCities.Sebastian]: 'Sebastian',
  [SaborCities.Seguin]: 'Seguin',
  [SaborCities.Selma]: 'Selma',
  [SaborCities.Seminole]: 'Seminole',
  [SaborCities.ShadyShores]: 'Shady Shores',
  [SaborCities.ShavanoPark]: 'Shavano Park',
  [SaborCities.Sheffield]: 'Sheffield',
  [SaborCities.Sherman]: 'Sherman',
  [SaborCities.Shiner]: 'Shiner',
  [SaborCities.SierraBlanca]: 'Sierra Blanca',
  [SaborCities.Sinton]: 'Sinton',
  [SaborCities.Sisterdale]: 'Sisterdale',
  [SaborCities.Skidmore]: 'Skidmore',
  [SaborCities.Smiley]: 'Smiley',
  [SaborCities.Smithville]: 'Smithville',
  [SaborCities.Somerset]: 'Somerset',
  [SaborCities.Somerville]: 'Somerville',
  [SaborCities.Sonora]: 'Sonora',
  [SaborCities.SouthPadreIsland]: 'South Padre Island',
  [SaborCities.Spicewood]: 'Spicewood',
  [SaborCities.Spofford]: 'Spofford',
  [SaborCities.Spring]: 'Spring',
  [SaborCities.SpringBranch]: 'Spring Branch',
  [SaborCities.StHedwig]: 'St Hedwig',
  [SaborCities.StHedwigOne]: 'St.Hedwig',
  [SaborCities.Staples]: 'Staples',
  [SaborCities.Startzville]: 'Startzville',
  [SaborCities.Stephenville]: 'Stephenville',
  [SaborCities.Stockdale]: 'Stockdale',
  [SaborCities.Stonewall]: 'Stonewall',
  [SaborCities.Streetman]: 'Streetman',
  [SaborCities.Sublime]: 'Sublime',
  [SaborCities.Sudan]: 'Sudan',
  [SaborCities.SugarLand]: 'Sugar Land',
  [SaborCities.SulphurSprings]: 'Sulphur Springs',
  [SaborCities.SunriseBeach]: 'Sunrise Beach',
  [SaborCities.SutherlandSprings]: 'Sutherland Springs',
  [SaborCities.Tarpley]: 'Tarpley',
  [SaborCities.Taylor]: 'Taylor',
  [SaborCities.Temple]: 'Temple',
  [SaborCities.TennesseeColony]: 'Tennessee Colony',
  [SaborCities.Terlingua]: 'Terlingua',
  [SaborCities.Terrell]: 'Terrell',
  [SaborCities.TerrellHills]: 'Terrell Hills',
  [SaborCities.Texarkana]: 'Texarkana',
  [SaborCities.TheHills]: 'The Hills',
  [SaborCities.TheWoodlands]: 'The Woodlands',
  [SaborCities.Thelma]: 'Thelma',
  [SaborCities.Thorndale]: 'Thorndale',
  [SaborCities.Thrall]: 'Thrall',
  [SaborCities.ThreeRivers]: 'Three Rivers',
  [SaborCities.Tilden]: 'Tilden',
  [SaborCities.Tivoli]: 'Tivoli',
  [SaborCities.Tomball]: 'Tomball',
  [SaborCities.Tow]: 'Tow',
  [SaborCities.TrophyClub]: 'Trophy Club',
  [SaborCities.Troy]: 'Troy',
  [SaborCities.Tulia]: 'Tulia',
  [SaborCities.Tulsita]: 'Tulsita',
  [SaborCities.Tyler]: 'Tyler',
  [SaborCities.Uhland]: 'Uhland',
  [SaborCities.Uncertain]: 'Uncertain',
  [SaborCities.Unincorp]: 'Unincorp',
  [SaborCities.UniversalCity]: 'Universal City',
  [SaborCities.Utopia]: 'Utopia',
  [SaborCities.Uvalde]: 'Uvalde',
  [SaborCities.ValleySpring]: 'Valley Spring',
  [SaborCities.VanHorn]: 'Van Horn',
  [SaborCities.Vanderpool]: 'Vanderpool',
  [SaborCities.Venus]: 'Venus',
  [SaborCities.Victoria]: 'Victoria',
  [SaborCities.Vidor]: 'Vidor',
  [SaborCities.VistaPoint]: 'Vista Point',
  [SaborCities.Volente]: 'Volente',
  [SaborCities.VonOrmy]: 'Von Ormy',
  [SaborCities.Waco]: 'Waco',
  [SaborCities.Waelder]: 'Waelder',
  [SaborCities.Waller]: 'Waller',
  [SaborCities.Waring]: 'Waring',
  [SaborCities.Waxahachie]: 'Waxahachie',
  [SaborCities.Weimar]: 'Weimar',
  [SaborCities.Welder]: 'Welder',
  [SaborCities.Welfare]: 'Welfare',
  [SaborCities.Weslaco]: 'Weslaco',
  [SaborCities.WestPoint]: 'West Point',
  [SaborCities.Westhoff]: 'Westhoff',
  [SaborCities.Wharton]: 'Wharton',
  [SaborCities.Whitehouse]: 'Whitehouse',
  [SaborCities.Whitesboro]: 'Whitesboro',
  [SaborCities.Whitney]: 'Whitney',
  [SaborCities.Whitsett]: 'Whitsett',
  [SaborCities.WillowCity]: 'Willow City',
  [SaborCities.Wimberley]: 'Wimberley',
  [SaborCities.Winchester]: 'Winchester',
  [SaborCities.Windcrest]: 'Windcrest',
  [SaborCities.Woodsboro]: 'Woodsboro',
  [SaborCities.Wrightsboro]: 'Wrightsboro',
  [SaborCities.Yancey]: 'Yancey',
  [SaborCities.Yoakum]: 'Yoakum',
  [SaborCities.YorkTown]: 'York Town',
  [SaborCities.Zapata]: 'Zapata',
  [SaborCities.Zorn]: 'Zorn'
};
